import {
  CountryCode,
  Currency,
  TsrctDemandRequestInput,
  TsrctLanguage,
  TsrctNegotiationCaseInput,
} from '@/generated/gql/graphql';
import { mapToTsrctNegotiationStrategyBoundaryRuleInput } from '~/components/NegotiationTermsForm/NegotiationTermsForm.util';

import { NegotiationCreateFormData } from './NegotiationCaseCreate.schema';

export const prepareDemandRequest = (submitData: NegotiationCreateFormData): TsrctDemandRequestInput => {
  const negotiationCaseSupplierId = submitData.supplier.internalId;
  const demandRequest = submitData.demandRequest;
  return {
    externalReference: demandRequest.externalReference,
    summary: demandRequest.summary,
    currency: (demandRequest.currency as Currency) ?? Currency.EUR,
    commodityGroupId: demandRequest.commodityGroupId,
    budget: demandRequest.budget ? demandRequest.budget.toString() : undefined,
    lineItems: demandRequest.lineItems.map((item) => ({
      position: item.position,
      title: item.title ?? '',
      description: item.description || undefined,
      unitId: item.unitId ?? undefined,
      quantity: item.quantity.toString(),
      shipmentTerms: item.shipmentTerms,
      commodityGroupId: item.commodityGroupId,
      preferredSupplierId: item.preferredSupplierId ?? negotiationCaseSupplierId,
      expectedPricePerUnit: item.expectedPricePerUnit ? item.expectedPricePerUnit.toString() : undefined,
      organizationId: item.organizationId,
      deliveryLocationId: item.deliveryLocationId,
    })),
  };
};

export const prepareNegotiationCases = (submitData: NegotiationCreateFormData): TsrctNegotiationCaseInput[] => {
  return [
    {
      options: {
        initiatedBy: submitData.options.initiatedBy,
        negotiationMode: submitData.options.negotiationMode,
        quoteMode: submitData.options.quoteMode,
        supplierInteractionMode: submitData.options.supplierInteractionMode,
        negotiationObjective: submitData.options.negotiationObjective,
      },
      strategy: {
        boundaryAdjustments: {
          historicNegotiations: submitData.boundaryAdjustments?.historicNegotiations ?? false,
          historicTenderData: submitData.boundaryAdjustments?.historicTenderData ?? false,
        },
        boundaryRules: mapToTsrctNegotiationStrategyBoundaryRuleInput(submitData.boundaries),
      },
      supplier: {
        internalId: submitData.supplier.internalId,
        externalReference: submitData.supplier.externalReference,
        name: submitData.supplier.name,
        location: {
          internalId: submitData.supplier.location?.internalId ?? '',
          city: submitData.supplier.location?.city,
          postalCode: submitData.supplier.location?.postalCode,
          address: submitData.supplier.location?.address,
          countryCode: submitData.supplier.location?.countryCode as CountryCode,
        },
        contact: {
          firstName: submitData.supplier.contact?.firstName,
          lastName: submitData.supplier.contact?.lastName,
          email: submitData.supplier.contact?.email,
          mobile: submitData.supplier.contact?.mobile,
          phone: submitData.supplier.contact?.phone,
          language: submitData.supplier.contact?.language?.toUpperCase() as TsrctLanguage,
        },
      },
    },
  ];
};
